<template>

  <tr v-if="true"
  :class="{'selected': selected[item.id]}">
    <td>

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

      <v-layout align-center>
        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.id] ? 'color1' : ''"> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <v-icon v-if="itemsMeta.newID === item.id" color="color1">mdi-new-box</v-icon>

        <!--
        <v-avatar
        color="text"
        size="22px"
        class="font-weight-light white--text mr-2">
          {{ (item.name || '?').charAt(0) }}
        </v-avatar>
        -->

        <div>
          <text-highlight style="white-space: initial;" :queries="nameKeywords" highlightClass="white--text color1" highlightStyle="">{{ item.name }}</text-highlight>
          <span v-if="item.deleted_at" class="ml-1 caption red--text">
            (deleted)
          </span>
          <div v-if="item.sku" class="caption textSecondary--text">
            SKU: {{ item.sku }}
          </div>
        </div>
      </v-layout>
    </td>
    <td>
      <template v-if="item.total_stock !== 0">

        <c-ms-ii
        :metric_definition="item" 
        :realValue="item.total_stock"
        :key="item.id"
        alwaysScale
        labelMode
        ></c-ms-ii>

        <div v-if="item.items.length > 1" class="caption overline textDisabled--text">
          <span>
            {{ item.items.length }}
          </span>
          BATCHES
        </div>
      </template>
      <div v-else class="grey--text caption">
        Out of stock!
      </div>
    </td>
    <td>
      <text-highlight class="text-truncate" :queries="searchFilters.id + ''" highlightClass="color1--text" highlightStyle="background: none;">{{ item.id }}</text-highlight>
    </td>
    <td>
      Coming soon
    </td>
  </tr>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  props: ['item', 'itemsMeta', 'selected', 'searchFilters'],
  components: {
    TextHighlight
  },
  computed: {
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    }
  }
}
</script>
